import React, { Component, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './pages/App.css';

const Home = lazy(() => import('./pages/jasa-desain-grafis'));
const About = lazy(() => import('./pages/About'));
const Artikel = lazy(() => import('./pages/tips-desain-grafis'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const Login = lazy(() => import('./pages/Login'));
const Users = lazy(() => import('./pages/Users'));
const Daftar = lazy(() => import('./pages/Daftar'));
const Admin = lazy(() => import('./pages/Admin'));
const Designer = lazy(() => import('./pages/Designer'));
const Reading = lazy(() => import('./pages/Reading'));
const Contact = lazy(() => import('./pages/contact'));
const PublishArticle = lazy(() => import('./pages/PublishArticle'));
const Register = lazy(() => import('./pages/Register'));
const Privasi = lazy(() => import('./pages/Privasi'));
const Ureturn = lazy(() => import('./pages/Ureturn'));
const Ucancel = lazy(() => import('./pages/Ucancel'));
const Chat = lazy(() => import('./pages/Chat'));
const Order = lazy(() => import('./pages/OrderDesign'));
const Retrive = lazy(() => import('./pages/Retrive'));
const StatusLanggananDesain = lazy(() => import('./pages/StatusLanggananDesain'));
const ShowSchedul = lazy(() => import('./pages/Schedule'));
const Schedule = lazy(() => import('./pages/setSchedule'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const Pricing = lazy(() => import('./pages/Pricing'));

export default function App() {
    return (
    <Router>
      <Suspense
        fallback={
          <div className="sign">
            <h3>Memuat...</h3>
          </div>
        }>
        <Routes>
          <Route path="/" exact element={<Home />} />
          <Route path="/jasa-desain-grafis" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/tips-desain-grafis" element={<Artikel />} />
          <Route path="/Portfolio" element={<Portfolio/>} />
          <Route path="/Login" element={<Login/>} />
          <Route path="/Users" element={<Users/>} />
          <Route path="/Daftar" element={<Daftar/>} />
          <Route path="/Admin" element={<Admin/>} />
          <Route path="/Designer" element={<Designer/>} />
          <Route path="/Reading" element={<Reading/>} />
          <Route path="/Contact" element={<Contact/>} />
          <Route path="/Publish" element={<PublishArticle/>} />
          <Route path="/Register" element={<Register/>} />
          <Route path="/Privasi" element={<Privasi/>} />
          <Route path="/Ureturn" element={<Ureturn/>} />
          <Route path="/Ucancel" element={<Ucancel/>} />
          <Route path="/Chat" element={<Chat/>} />
          <Route path="/OrderDesign" element={<Order/>} />
          <Route path="/Retrive" element={<Retrive/>} />
          <Route path="/StatusLanggananDesain" element={<StatusLanggananDesain/>} />
          <Route path="/ShowSchedul" element={<ShowSchedul/>} />
          <Route path="/Schedule" element={<Schedule/>} />
          <Route path="/ResetPassword" element={<ResetPassword/>} />
          <Route path="/Pricing" element={<Pricing/>} />
        </Routes>
      </Suspense>
    </Router>
    )
}